import React, { FC } from "react";

import { ServiceDto } from "@apiModels/ServiceDto.csharp";
import { BookingLabelsDto } from "@apiModels/BookingLabelsDto.csharp";

type PriceDetailsButtonProps = {
  service: ServiceDto;
  bookingLabels: BookingLabelsDto;
  buttonCss: string;
  onClick: () => void;
};

export const PriceDetailsButton: FC<PriceDetailsButtonProps> = ({
  service,
  bookingLabels,
  buttonCss,
  onClick,
}) => {
  const label =
    service.priceDetailsLabel || bookingLabels.commonLabels.priceDetailsLabel;

  return (
    <button className={buttonCss} onClick={onClick}>
      {label}
    </button>
  );
};
